import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import type { RootState } from '../../../../../../store';

export default function useTreatmentPlanV3MedicalPageState() {
  const { treatmentPlanId } = useParams<'treatmentPlanId'>();
  const loadedPlanId = useSelector((state: RootState) => state.treatmentPlanV3.medicalPageTreatmentPlanId);
  const page = useSelector((state: RootState) => state.treatmentPlanV3.medicalPage);
  const isLoading = useSelector((state: RootState) => state.treatmentPlanV3.medicalPageLoading);
  const hasLoadError = useSelector((state: RootState) => state.treatmentPlanV3.medicalPageError != null);
  const isUpdating = useSelector((state: RootState) => state.treatmentPlanV3.updateMedicalInfoLoading);
  const isSavingDiagnosis = useSelector((state: RootState) => state.treatmentPlanV3.createMedicalDiagnosisLoading || state.treatmentPlanV3.updateMedicalDiagnosisLoading || state.treatmentPlanV3.deleteMedicalDiagnosisLoading);
  const isSavingSelection = useSelector((state: RootState) => state.treatmentPlanV3.createMedicalSelectionLoading || state.treatmentPlanV3.deleteMedicalSelectionLoading);
  const isCurrentPlan = loadedPlanId === treatmentPlanId;
  return { page: isCurrentPlan ? page : null, isLoading: isLoading || !isCurrentPlan, hasLoaded: isCurrentPlan && page != null, hasLoadError: isCurrentPlan && hasLoadError, isUpdating, isSavingDiagnosis, isSavingSelection };
}
